module.exports = __webpack_public_path__ + "static/img/7-title.995c774.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/7-title.png
// module id = z/k8
// module chunks = 0